const initialState = () => ({
    all: []
});

const ordersReducer = (state = initialState(), action) => {
    const newState = Object.assign({}, state);
    switch (action.type) {
        case 'ORDERS_RECEIVED':
            newState.all = action.payload.sort((a, b) => {
                if (a.data > b.date ) return -1;
                if (a.date < b.date ) return 1;
                return 0;
            });
            return newState;
        case 'LOGOUT':
            return Object.assign({}, initialState());
        default:
            return state;
    }
};

export default ordersReducer;
